import React, { useEffect, useState, useRef, useCallback } from "react";
import Card from "../ui/Card";
import ConsoleHeader from "./ConsoleHeader";
import InventoryDetails from "./InventoryDetails";
import InventoryController from "../controllers/InventoryController";
import { useSession } from "../hooks/useSession";
import GlobalController from "../controllers/GlobalConroller";
import HomeController from "../controllers/HomeController";
import POSController from "../controllers/POSController";
import CustomersController from "../controllers/CustomersController";
import ReconciliationController from "../controllers/ReconciliationController";
import { ROUTES } from "../utils/Routes";
import SuppliersController from "../controllers/SuppliersController";
import ReportsController from "../controllers/ReportsController";
import Label from "../ui/Label";
import Alert from "../ui/Alert";
import { pubCall } from "../utils/PubSub";
import dayjs from "dayjs";
import OrderProcessingController from "../controllers/OrderProcessingController";
import OrdersController from "../controllers/OrdersController";
import { getSignal } from "../App";
import { showConfirm, showInfo } from "../utils/Utils";
import TestController from "../controllers/TestController";


export default function Console(props) {
    const { signal = {}, title = "" } = props;

    // Set the default to home
    const [active, setActive] = useState("home");


    const init = {
        home: true,
        orders: false,
        customers: false,
        pos: false,
        inventory: false,
        processing: false,
        suppliers: false,
        reports: false,
        test: false,
    }
    const [mounted, setMounted] = useState({ ...init });

    const [resetKey, setResetKey] = useState(0);

    const show = useCallback((name) => {

        window.ac = name;
        switch (name) {
            // Reset on home...
            case "home":
                window.bm_state.value = ROUTES.HOME.MENU;
                setMounted({ ...init });
                setActive(name);
                setResetKey((k) => k + 1);
                return;
            case "orders":
                window.bm_state.value = ROUTES.ORDERS.ORDERS;
                break;
            case "customers":
                window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
                break;
            case "pos":
                window.bm_state.value = ROUTES.POS.POS;
                break;
            case "inventory":
                window.bm_state.value = ROUTES.INVENTORY.INVENTORY;
                break;
            case "processing":
                window.bm_state.value = ROUTES.PROCESSING.PROCESSING;
                break;
            case "suppliers":
                window.bm_state.value = ROUTES.SUPPLIERS.SUPPLIERS;
                break;
            case "reports":
                window.bm_state.value = ROUTES.REPORTS.REPORTS;
                break;
            case "test":
                window.bm_state.value = ROUTES.MISC.TEST;
                break;
        }


        setMounted((m) =>
            m[name] ? m : { ...m, [name]: true }
        );
        setActive(name);
    }, []);




    const [visited, setVisited] = useState(new Set(["home"]));
    const lastBmState = useRef({});

    let _ws_only = false;
    let mode = process.env.REACT_APP_API || 'inherit';

    if (mode === "live") {
        _ws_only = true;
    }


    const WS_ONLY = _ws_only;

    const [controller, setController] = useState("home");


    // useEffect(() => {
    //     setVisited(prev => new Set(prev).add(controller));
    // }, [controller]);



    // useEffect(() => {
    //     // [TODO] implement
    //     return;
    //     const onSwitchController = (e) => switchController(e.detail);
    //     window.addEventListener("switchController", onSwitchController);
    //     return () => {
    //         window.removeEventListener("switchController", onSwitchController);
    //     }
    // }, []);




    //[TEMP] SHOW ONLY RECONCILIATION
    useEffect(() => {
        window.bm_state.value = (WS_ONLY) ? ROUTES.RECONCILIATION.RECONCILIATION : ROUTES.HOME.MENU;
    }, [])



    // const switchController = (next) => {

    //     lastBmState.current[controller] = window.bm_state.value;

    //     window.ac = next;
    //     // Switch screens
    //     setController(next);
    //     if (next === "home") {
    //         // clear visited
    //         Object.keys(lastBmState.current).forEach(key => {
    //             if (key !== "home") delete lastBmState.current[key];
    //         });
    //         // clear persistant
    //         setVisited(new Set(["home"]));
    //     }

    //     const saved = lastBmState.current[next];
    //     if (saved) {
    //         window.bm_state.value = saved;
    //     }
    // };



    // const getController = (_controller) => {
    //     switch (_controller) {
    //         case "home":
    //             return <HomeController setController={switchController} signal={signal} />
    //         case "orders":
    //             return <OrdersController setController={switchController} signal={signal} />
    //         case "customers":
    //             return <CustomersController setController={switchController} signal={signal} />
    //         case "pos":
    //             return <POSController setController={switchController} signal={signal} />
    //         case "inventory":
    //             return <InventoryController setController={switchController} signal={signal} />
    //         case "processing":
    //             return <OrderProcessingController setController={switchController} signal={signal} />
    //         case "suppliers":
    //             return <SuppliersController setController={switchController} signal={signal} />
    //         case "reports":
    //             return <ReportsController setController={switchController} signal={signal} />
    //         case "test":
    //             return <TestController setController={switchController} signal={signal} />
    //     }

    // }

    // const drawController = () => {

    //     // [TEMP] SHOW ONLY RECONCILIATION
    //     if (WS_ONLY) {
    //         return <ReconciliationController WS_ONLY={WS_ONLY} route={ROUTES.RECONCILIATION.RECONCILIATION} setController={setController} signal={signal} />
    //     }



    //     //return getController(controller);

    //     return Array.from(visited).map(item => {
    //         return (
    //             <div
    //                 key={item}
    //                 inert={item !== controller ? "" : undefined}
    //                 style={{
    //                     position: item === controller ? "relative" : "absolute",
    //                     // display: item === controller ? "block" : "none",
    //                     top: 0,
    //                     left: 0,
    //                     width: "100%",
    //                     visibility: item === controller ? "visible" : "hidden",
    //                     pointerEvents: item === controller ? "auto" : "none",
    //                 }}
    //             >
    //                 {getController(item)}
    //             </div>
    //         )
    //     })



    // }

    const [isSuspended, setIsSuspended] = useState(false);

    useEffect(() => {
        if (window.credentials.store_id == 11) {
            showConfirm({
                route: window.bm_state.value,
                description: <div style={{ "textAlign": "center" }}>You are logged in as Mosaic Books - Orders are real.  <br /> Do you want to continue?</div>,
                title: "Warning",
                callback: (e) => {
                    if (!e) {
                        window.history.replaceState(null, '', '/');
                        window.location.reload();
                    }
                }
            })
        }

    }, [])




    return (
        <div key={resetKey}>
            {isSuspended && (
                <div
                    onClick={(e) => {
                        setIsSuspended(false);
                    }}

                    style={{
                        position: "fixed",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 9999,
                        cursor: "pointer",
                    }}
                >
                </div>
            )}


            <div style={{
                // filter: isSuspended ? "grayscale(100%) brightness(0.7)" : "none",
                // transition: "filter 0.2s ease"
            }}>


                {/* //[TEMP] SHOW ONLY RECONCILIATION */}
                {/* <GlobalController controller={controller} setController={switchController} WS_ONLY={WS_ONLY} signal={signal} /> */}
                {/* <div style={{ width: 'clamp(1180px, 100vw, 1440px)', "height": "calc(100vh - 50px)", "minHeight": "598px", "margin": "0 auto" }}>
                    <ConsoleHeader title="" signal={signal} />
                    {drawController()}
                </div> */}

                <div style={{ width: 'clamp(1180px, 100vw, 1440px)', "height": "calc(100vh - 50px)", "minHeight": "598px", "margin": "0 auto" }}>
                    <ConsoleHeader title="" signal={signal} />
                    {/* Home */}
                    {mounted.home && (
                        <div style={{ display: active === "home" ? "block" : "none" }}>
                            <HomeController setController={show} signal={{signal}} />
                        </div>
                    )}

                    {/* Orders */}
                    {mounted.orders && (
                        <div style={{ display: active === "orders" ? "block" : "none" }}>
                            <OrdersController setController={show} signal={signal} />
                        </div>
                    )}

                    {/* Customers */}
                    {mounted.customers && (
                        <div style={{ display: active === "customers" ? "block" : "none" }}>
                            <CustomersController setController={show} signal={signal} />
                        </div>
                    )}

                    {/* POS */}
                    {mounted.pos && (
                        <div style={{ display: active === "pos" ? "block" : "none" }}>
                            <POSController setController={show} signal={signal} />
                        </div>
                    )}

                    {/* Inventory */}
                    {mounted.inventory && (
                        <div style={{ display: active === "inventory" ? "block" : "none" }}>
                            <InventoryController setController={show} signal={signal} />
                        </div>
                    )}

                    {/* Processing */}
                    {mounted.processing && (
                        <div style={{ display: active === "processing" ? "block" : "none" }}>
                            <OrderProcessingController setController={show} signal={signal} />
                        </div>
                    )}

                    {/* Suppliers */}
                    {mounted.suppliers && (
                        <div style={{ display: active === "suppliers" ? "block" : "none" }}>
                            <SuppliersController setController={show} signal={signal} />
                        </div>
                    )}

                    {/* Reports */}
                    {mounted.reports && (
                        <div style={{ display: active === "reports" ? "block" : "none" }}>
                            <ReportsController setController={show} signal={signal} />
                        </div>
                    )}

                    {/* Test */}
                    {mounted.test && (
                        <div style={{ display: active === "test" ? "block" : "none" }}>
                            <TestController setController={show} signal={signal} />
                        </div>
                    )}
                </div>
            </div>
            <div style={{ "position": "absolute", top: "0px", left: "0px" }}>
                <pre><small>{JSON.stringify(mounted, null, 2)}</small></pre>
            </div>
        </div>
    )
}